const PropTypes = require('prop-types')
const isLoggedIn = require('module/viewer/helpers/is_logged_in')
const hasFeature = require('module/user/helpers/has_feature')

// component which renders children if the viewer is logged in and not pro
function FreeComponent({ children }, { viewer }) {
    if (! isLoggedIn(viewer)) return null
    if (hasFeature(viewer, 'upgrade')) return null
    if (hasFeature(viewer, 'standard')) return null
    return children
}
FreeComponent.propTypes = {
    children: PropTypes.any,
}
FreeComponent.contextTypes = {
    viewer: PropTypes.object.isRequired,
}

module.exports = {
    FreeComponent,
}
